import React from 'react';
import Icon from './Icon';

const PAIRINGS = [
  ['Chicken Biryani', 'Mango Lassi'],
  ['Tacos al Pastor', 'Horchata'],
  ['Butter Chicken', 'Garlic Naan'],
  ['Gujarati Thali', 'Shrikhand'],
];

export default function Upsell() {
  return (
    <section className="section light" id="upselling">
      <div className="wrap split">
        <div className="split__copy" data-reveal>
          <p className="eyebrow">AI upselling</p>
          <h2 className="h2">
            Your best server's instinct, <em>on every single call.</em>
          </h2>
          <p className="lead lead--dark">
            Great servers know the lassi goes with the biryani. Your AI knows too, because you told it.
            It suggests the add-on once, at the right moment, and never pushes.
          </p>
          <ul className="checks">
            <li>
              <Icon name="check" size={18} />
              <span>
                <strong>You choose the pairings.</strong> Pick a complementary add-on for any dish
                in the admin portal.
              </span>
            </li>
            <li>
              <Icon name="check" size={18} />
              <span>
                <strong>Asked once, right before the total.</strong> If a caller has more than one
                dish, it suggests the add-on for the most valuable one.
              </span>
            </li>
            <li>
              <Icon name="check" size={18} />
              <span>
                <strong>Sold out? It offers the right substitute.</strong> Pick up to three backups
                per dish, so callers hear "we have lamb biryani instead" and not "anything else?".
              </span>
            </li>
            <li>
              <Icon name="check" size={18} />
              <span>
                <strong>Tips on the kiosk.</strong> One tap for 10%, 15%, 20% or a custom amount at
                checkout.
              </span>
            </li>
          </ul>
        </div>

        <div className="pairings" data-reveal>
          <div className="pairings__card">
            <div className="pairings__head">
              <span>Upsell pairings</span>
              <span className="pill pill--soft">Admin portal</span>
            </div>
            {PAIRINGS.map(([dish, addon]) => (
              <div key={dish} className="pairing">
                <span className="pairing__dish">{dish}</span>
                <span className="pairing__arrow">
                  <Icon name="plus" size={14} />
                </span>
                <span className="pairing__add">{addon}</span>
              </div>
            ))}
          </div>
          <div className="pairings__card pairings__card--alt">
            <div className="pairings__head">
              <span>Sold out today</span>
              <span className="pill pill--warn">Substitutes</span>
            </div>
            <div className="pairing pairing--out">
              <span className="pairing__dish">
                <s>Goat Biryani</s>
              </span>
            </div>
            <div className="subs">
              <span>Lamb Biryani</span>
              <span>Chicken Biryani</span>
              <span>Mutton Curry</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
